import { changeAntdTheme } from './core/util';

// Repurposed usage of https://github.com/luffyZh/mini-dynamic-antd-theme

export { changeAntdTheme };
